import { useQuery } from '@tanstack/react-query';
import { COMPANY_ENTITIES_KEY } from 'src/utils/constants/queryKeys';
import { getCompanyEntities } from '../services/fn-api/Company';

export const useGetCompanyEntities = (companyId: number, params: object = {}) => {
  return useQuery({
    queryKey: [COMPANY_ENTITIES_KEY, companyId],
    queryFn: () => getCompanyEntities({ ...params, companyId }),
    enabled: !!companyId,
  });
};
